import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";

import Dashboard from "components/menu/dashboard/index";

const DashboardRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={Dashboard}
            />
        </Switch>
    </div>
);

export default connect()(DashboardRouter);
